module.exports = "/src/views/player/gta5devmenu/elements/minigames/images/logo-sapper.png";